import * as ripsService from '@/services/rips-api.service';


import { camelizeKeys } from "humps";
import { BRANCHES_ERROR, BRANCHES_LOADING, BRANCHES_SUCCESS, HEALTHCARE_PROVIDERS_ERROR, HEALTHCARE_PROVIDERS_LOADING, HEALTHCARE_PROVIDERS_SUCCESS, RIPS_HISTORY_LOADING, RIPS_HISTORY_ERROR, RIPS_HISTORY_SUCCESS,RIPS_CONTENT_CLEAR,FILTER_SUCCESS,FILTER_CLEAR, DOWNLOAD_FILES_LOADING, DOWNLOAD_FILES_ERROR } from "./types";

const getBranches = async ({ commit, rootGetters }) => {
    const companyId = rootGetters.tokenExtensions.connectCompanyId || ''
    commit(BRANCHES_LOADING, true)
    try {
        const response = await ripsService.getBranches(companyId);
        commit(BRANCHES_SUCCESS, camelizeKeys(response.data))
        commit(BRANCHES_LOADING, false)
    } catch (error) {
        commit(BRANCHES_ERROR, error)
        commit(BRANCHES_LOADING, false)
    }
};

const getHealthcareProviders = async ({ commit, rootGetters }) => {
    const companyId = rootGetters.tokenExtensions.connectCompanyId || ''
    commit(HEALTHCARE_PROVIDERS_LOADING, true)
    try {
        const response = await ripsService.getHealthcareProviders(companyId);
        const data = response.data.map((item) => {
            return {
                ...item,
                name: `${item.taxpayer_identification_number} - ${item.provider_name}`
            }
        })
        commit(HEALTHCARE_PROVIDERS_SUCCESS, camelizeKeys(data))
        commit(HEALTHCARE_PROVIDERS_LOADING, false)
    } catch (error) {
        commit(HEALTHCARE_PROVIDERS_ERROR, error)
        commit(HEALTHCARE_PROVIDERS_LOADING, false)
    }
};

const getRIPSHistory = async ({ commit, rootGetters }, payload) => {
    const companyId = rootGetters.tokenExtensions.connectCompanyId || ''
    commit(RIPS_HISTORY_LOADING, true)
    try {
        const response = await ripsService.getRIPSHistory(companyId, payload);
        commit(RIPS_HISTORY_SUCCESS, camelizeKeys(response.data))
        commit(RIPS_HISTORY_LOADING, false)
    } catch (error) {
        commit(RIPS_HISTORY_ERROR, error)
        commit(RIPS_HISTORY_LOADING, false)
    }
};

const clearRipsHistory = ({ commit })=>{
    commit(RIPS_CONTENT_CLEAR)
};

const setFilters =  ({ commit }, filters) => {
    commit(FILTER_SUCCESS)
    localStorage.setItem('filters', JSON.stringify(filters));
};

const clearFilters =  ({ commit }, filters) => {
    commit(FILTER_CLEAR)
    localStorage.setItem('filters', JSON.stringify(filters));
};

const postDownloadFiles =  ({ commit }, payload) => {
    commit(DOWNLOAD_FILES_LOADING, true)
    ripsService.postDownloadFiles(payload)
        .then(response => {
            commit(DOWNLOAD_FILES_LOADING, false)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'documentos.zip');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit(DOWNLOAD_FILES_LOADING, false)
            commit(DOWNLOAD_FILES_ERROR, error)
        })
};





export default {
    getBranches,
    getHealthcareProviders,
    getRIPSHistory,
    clearRipsHistory,
    setFilters,
    clearFilters,
    postDownloadFiles
}